import { useEffect } from 'react';
import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import HeroSection from './components/HeroSection';
import FeaturedSection from './components/FeaturedSection';
import HotComicsSection from './components/HotComicsSection';
import PlatformFeaturesSection from './components/PlatformFeaturesSection';
import ReviewsSection from './components/ReviewsSection';
import CTABannerSection from './components/CTABannerSection';

const siteUrl =
  import.meta.env.VITE_SITE_URL ||
  (typeof window !== 'undefined' ? window.location.origin : 'https://yuexing.org.cn');

export default function Home() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <>
      <Navbar />
      <main>
        <HeroSection />
        <FeaturedSection />
        <HotComicsSection />
        <PlatformFeaturesSection />
        <ReviewsSection />
        <CTABannerSection />
      </main>
      <Footer />

      {/* Structured Data */}
      <script
        type="application/ld+json"
        dangerouslySetInnerHTML={{
          __html: JSON.stringify({
            '@context': 'https://schema.org',
            '@type': 'WebSite',
            name: '歪歪漫画网',
            url: `${siteUrl}/`,
            description:
              '歪歪漫画网提供歪歪漫画免费网站入口与韩国无遮羞漫画资源，韩漫歪歪漫画免费看每日大赛实时上线。网红反差视频、明星塌房内幕大瓜全网首发。',
            potentialAction: {
              '@type': 'SearchAction',
              target: `${siteUrl}/search?q={search_term_string}`,
              'query-input': 'required name=search_term_string',
            },
          }),
        }}
      />
    </>
  );
}
